var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-controls__rounds"},[_c('div',{staticClass:"game-controls__rounds--actual"},[_vm._v(_vm._s(_vm.turn))]),_c('div',{staticClass:"game-controls__rounds--total"},[_vm._v(" of "+_vm._s(_vm.maxTurn)+" "),_c('br'),_vm._v("rounds ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }